import type { CompanySummary, LogoTone } from '../../types';

/**
 * Logo da empresa (RNF12 / RNF15).
 *
 * Com `logoUrl` mostra a imagem; sem, um quadrado com as iniciais na cor de
 * serie da empresa. A cor vem do cadastro (`logoTone`), nao da posicao na
 * lista: trocar a ordem das empresas nao pode trocar a cor de nenhuma.
 */

const TONE: Readonly<Record<LogoTone, string>> = {
  1: 'bg-series-1',
  2: 'bg-series-2',
  3: 'bg-series-3',
  4: 'bg-series-4',
  5: 'bg-series-5',
  6: 'bg-series-6',
  7: 'bg-series-7',
  8: 'bg-series-8',
};

const SIZE: Readonly<Record<'sm' | 'md' | 'lg' | 'xl', string>> = {
  sm: 'h-7 w-7 rounded-lg text-[10px]',
  md: 'h-9 w-9 rounded-xl text-xs',
  lg: 'h-12 w-12 rounded-xl text-sm',
  xl: 'h-16 w-16 rounded-2xl text-lg',
};

export function CompanyLogo({ company, size = 'md', className = '' }: { readonly company: Pick<CompanySummary, 'name' | 'logoInitials' | 'logoTone' | 'logoUrl'>; readonly size?: 'sm' | 'md' | 'lg' | 'xl'; readonly className?: string }): JSX.Element {
  if (company.logoUrl !== null) {
    return <img src={company.logoUrl} alt={`Logo de ${company.name}`} className={`${SIZE[size]} shrink-0 object-cover shadow-soft ${className}`} />;
  }
  return (
    <span aria-hidden="true" className={`grid shrink-0 place-items-center font-bold text-white shadow-soft ${TONE[company.logoTone]} ${SIZE[size]} ${className}`}>
      {company.logoInitials}
    </span>
  );
}
